import * as React from 'react';

const SvgMiscClockFill = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M12 22c5.51 0 10-4.49 10-10S17.51 2 12 2 2 6.49 2 12s4.49 10 10 10Zm-1-10.46V7h2v5.46l-3.82 3.3-1.31-1.51L11 11.54Z" })
);

export { SvgMiscClockFill as default };
//# sourceMappingURL=MiscClockFill.es.js.map
